import { title } from "framer-motion/client";

const musicTexts = {
  fr: {
    title: "musique",
    buttons: ["Productions", "Personnel", "Inédit"],
    switchLang: "Click here for the english version",
  },
  en: {
    title: "music",
    buttons: ["Productions", "Personal", "Unreleased"],
    switchLang: "Cliquez ici pour la version française",
  },
};

export default musicTexts;
